import type { EmblaOptionsType } from "embla-carousel";
import type { AutoplayOptionsType } from "embla-carousel-autoplay";

export const DESKTOP_VISIBLE_CARDS = 3;
export const TABLET_VISIBLE_CARDS = 2;

export const SLIDE_GAP = 12;

export const AUTOPLAY_DELAY_MS = 4500;

export const EMBLA_OPTIONS: EmblaOptionsType = {
  loop: true,
  align: "start",
};

export const AUTOPLAY_OPTIONS: AutoplayOptionsType = {
  delay: AUTOPLAY_DELAY_MS,
  stopOnInteraction: false,
  stopOnMouseEnter: true,
};
